export const getAvatar = ({ avatar, first_name, last_name }) => {
  const two = `${first_name.length > 0 && first_name[0]}${
    last_name.length > 0 && last_name[0]
  }`

  return avatar ? (
    <img src={`${process.env.REACT_APP_S3_HOST}/${avatar}`} alt="avatar" />
  ) : (
    <div>{two}</div>
  )
}
